module.exports = {"data":{"site":{"siteMetadata":{"v1":"/availity-uikit/v1/","v2":"/availity-uikit/v2/","title":"UIkit","description":"Availity UIKit powered by Bootstrap 4","keywords":"css, bootstrap, uikit","version":"3.1.0"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 89
// module chunks = 60335399758886 114276838955818